import { DatePipe } from "@angular/common";
import { TextboxController } from "./textbox-controller.interface";
import { TextboxComponent } from "../textbox.component";

export class DateController implements TextboxController {
    component: TextboxComponent;


    constructor() {}

    setup(args) {
        this.component.showMask = true;
        this.component.mask = "M0/d0/0000";
        this.component.dropMaskSpecialCharacters = false;
    }
}